/**** mgt.Trip */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'MarshVariants',
  title: 'Варианты маршрутов',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    route: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Routes',
      index: 'route_id',
      fields: ['route_short_name'],
      format: (elem: any) => elem['route_short_name'],
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'route_id',
      title: 'Маршрут',
      type: 'number',
      required: true,
      connection: 'route',
    },
    {
      name: 'startdate',
      title: 'Дата ввода в действие',
      type: 'date',
      required: false,
    },
    {
      name: 'enddate',
      title: 'Дата окончания действия',
      type: 'date',
      required: false,
    },
    {
      name: 'description',
      title: 'Описание',
      type: 'text',
      required: false
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px',
    },
  ],
  newTemplate: {
    id: null,
    route_id: null,
    startdate: null,
    enddate: null,
    do_not_update: true,
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'route_variant_id',
        field: 'id',
      },{
        title: 'route_id',
        field: 'route_id',
      },{
        title: 'route_variant_date_start',
        field: 'startdate',
      },{
        title: 'route_variant_date_end',
        field: 'enddate',
      },{
        title: 'route_variant_desc',
        field: 'description',
      }
    ],
    example: `1;1;2020-01-01 00:00:00.000;2030-01-01 00:00:00.000;Описание`,
  },
  export: {
    fields: [
      {
        name: 'route_id',
        title: 'Маршрут',
        connectionGetField: 'route_short_name',
      },
      {
        name: 'vehicle_type',
        title: 'Тип ТС',
        connection: 'vehicle_type'
      },
      {
        name: 'startdate',
        title: 'Дата ввода в действие',
        type: 'date'
      },
      {
        name: 'enddate',
        title: 'Дата окончания действия',
        type: 'date'
      },
      {
        name: 'description',
        title: 'Описание'
      },
    ],
    connections: {
      vehicle_type: {
        schema: 'mgt',
        table: 'Routes',
        index: 'route_id',
        fields: ['route_short_name'],
        format: (elem: any) => elem['route_short_name'],
        customsql:
          `SELECT
              v.route_type
          FROM
              mgt."MarshVariants" mv
          INNER JOIN
              mgt."Routes" r ON mv.route_id = r.route_id 
          INNER JOIN
              mgt."Agency" ag ON r."Agency_id" = ag.agency_id
          INNER JOIN
              mgt."Depot" dp ON ag.agency_id = dp.agency_id
          INNER JOIN
              mgt."Vehicle" v ON dp.depot_id = v.depot_id`,
      },
    }
  }
};

export default config;
